import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import AdminPage from "./pages/AdminPage";
import LeadFormPage from "./pages/LeadFormPage";
import SuccessPage from "./pages/SuccessPage";
import Header from "./components/Header";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider, useLanguage } from "./context/LanguageContext";

function AppLayout() {
  const { isRTL } = useLanguage();
  const location = useLocation();
  const isAdmin = location.pathname === '/admin';
  const isForm = location.pathname === '/form';
  const isSuccess = location.pathname === '/successful';
  const hideChrome = isAdmin || isForm || isSuccess;

  return (
    <div className="App" dir={isRTL ? 'rtl' : 'ltr'}>
      {!hideChrome && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/form" element={<LeadFormPage />} />
        <Route path="/successful" element={<SuccessPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      {!hideChrome && <Toaster position="top-right" />}
    </div>
  );
}

function AppContent() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <AppContent />
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
